import "./StatusIcons.less";
import React from "react";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderMark from "../OrderMark";
import { buildFlags } from "@/utils/OrderUtils";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import { buildOrderStatusIcon } from "./util";
import useDoudianTagIcons from "./hooks/useDouDianTagIcons";
import useTaobaotagIcons from "./hooks/useTaobaotagIcons";
import useXhsTagIcons from "./hooks/useXhsTagIcons";
import useJlTagIcons from "./hooks/useJlTagIcons";
import useKwaiTagIcons from "./hooks/useKwaiTagIcons";
import useCommonTagIcons from "./hooks/useCommonTagIcons";
import useManualShopTagIcons from "./hooks/useManualShopTagIcons";
import useChannelshopTagIcons from "./hooks/useChannelshopTagIcons";
import useAliTagIcons from "./hooks/useAliTagIcons";
import usePddTagIcons from "./hooks/usePddTagIcons";
import useJdTagIcons from "./hooks/useJdTagIcons";
import useOrderInfoIcons from "./hooks/useOrderInfoIcons";

interface StatusIconsProps {
    order: OrderDTO;
    showOrderStatusIcon?: boolean;
    showDropshippingStatusIcon?: boolean;
    showOnHold?: boolean;
}

function useOrderColumnsIcons(order: OrderDTO, shop: ShopDTO) {
    const orderTagSet = new Set<OrderTag>();
    order.tags?.forEach((tag) => {
        orderTagSet.add(tag);
    });

    const commonTagIcons = useCommonTagIcons(order, orderTagSet, shop);
    const orderInfoIcons = useOrderInfoIcons(order, orderTagSet, shop);
    const jdTagIcons = useJdTagIcons(order, orderTagSet, shop);
    const pddTagIcons = usePddTagIcons(order, orderTagSet, shop);
    const aliTagIcons = useAliTagIcons(order, orderTagSet, shop);
    const channelshopTagIcons = useChannelshopTagIcons(order, orderTagSet, shop);
    const manualShopTagIcons = useManualShopTagIcons(order, orderTagSet, shop);
    const doudianTagIcons = useDoudianTagIcons(order, orderTagSet, shop);
    const taobaotagIcons = useTaobaotagIcons(order, orderTagSet, shop);
    const xhsTagIcons = useXhsTagIcons(order, orderTagSet, shop);
    const jlTagIcons = useJlTagIcons(order, orderTagSet, shop);
    const kwaiTagIcons = useKwaiTagIcons(order, orderTagSet, shop);

    const icons = [
        ...orderInfoIcons,
        ...commonTagIcons,
        ...jdTagIcons,
        ...pddTagIcons,
        ...aliTagIcons,
        ...channelshopTagIcons,
        ...manualShopTagIcons,
        ...doudianTagIcons,
        ...taobaotagIcons,
        ...xhsTagIcons,
        ...jlTagIcons,
        ...kwaiTagIcons,
    ];

    return <div className="status-icons">{icons}</div>;
}

function buildOrderMarks(order: OrderDTO) {
    const orderMarkIds: number[] = [];

    if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders) {
        order.childOrders.forEach((childOrder) => {
            const { markId } = childOrder;

            if (markId && !orderMarkIds.includes(markId)) {
                orderMarkIds.push(markId);
            }
        });
    } else {
        const { markId } = order;

        if (markId && !orderMarkIds.includes(markId)) {
            orderMarkIds.push(markId);
        }
    }

    return (
        <div>
            {orderMarkIds.map((markId) => {
                return <OrderMark id={markId} key={markId} className="mb5 mr5" />;
            })}
        </div>
    );
}

const StatusIcons: React.FC<StatusIconsProps> = function (props) {
    const { order, showOrderStatusIcon, showOnHold } = props;

    const { shopMapping } = useGlobalStore();

    const shop = shopMapping.get(order.shopId);

    const icons = useOrderColumnsIcons(order, shop);
    const flags = buildFlags(order);
    const orderMarks = buildOrderMarks(order);

    return (
        <div>
            {orderMarks}

            {/* 是否显示订单状态图标，如：未付款、已发货（用于 近3个月订单列表、快速查单页面） */}
            {showOrderStatusIcon ? <p className="mb5">{buildOrderStatusIcon(order)}</p> : null}

            {showOnHold && order?.isOnHold ? (
                <p className="mb5">
                    <span className="order-status-label label-warning small">挂起</span>
                </p>
            ) : null}

            {flags}

            {icons}
        </div>
    );
};

export default observer(StatusIcons);
